export class DistributionLane {
    id!: string;
    name!: string;
    createdAt!:string
  }